import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import { Switch } from '@/global/components/Switch'
import dayjs from 'dayjs'
import { hasPermission } from 'hooks/useBackendMenu'
import React, { useState } from 'react'
import { valoresValeAlimentacao } from 'service/api'
import { axiosInstance } from 'service/api/axios'
import { toast } from 'sonner'
import { useStore } from 'store'

const AlterarPagamento: React.FC<GridCellParams> = ({ value, row }) => {
    const empresaId = useStore(state => state.companyId)
    const [isLoading, setIsLoading] = useState(false)
    const temPermissao = hasPermission(['update', 'ValeAlimentação'])

    const handleChange = (_: any, checked: boolean) => {
        setIsLoading(true)
        axiosInstance
            .put('/v1/vale-alimentacao/pagar', {
                empresaId,
                funcionarioId: row.funcionarioId,
                data: dayjs.utc(row.data).toDate(),
                pagar: checked === true,
            })
            .then(async () => {
                await valoresValeAlimentacao.invalidateQueries()
                toast.success('Pagamento atualizado com sucesso')
            })
            .catch(error => {
                toast.error('Erro ao atualizar pagamento')
                console.error(error)
            })
            .finally(() => setIsLoading(false))
    }

    return (
        <Switch
            checked={!!value}
            onChange={handleChange}
            disabled={!temPermissao || isLoading}
        />
    )
}

export default AlterarPagamento
